import * as React from 'react';
import { Button, UIHeading2 } from '@cian/ui-kit';

import styles from './styles.css';

interface ISuccessMessage {
  onClose: () => void;
  message: string;
}
export const SuccessMessage: React.FC<ISuccessMessage> = ({ onClose, message }) => {
  return (
    <div className={styles['success-message']}>
      <div className={styles['icon']} />
      <div className={styles['title']}>
        <UIHeading2>{message}</UIHeading2>
      </div>
      <div className={styles['control']}>
        <Button onClick={onClose} size="L">
          Спасибо
        </Button>
      </div>
    </div>
  );
};
